module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-35.e7a9ac00.png";